import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_KEY = 'attenda_device_ids';

interface StoredDeviceIds {
  [key: string]: string; // key will be meetingId_stateCode
}

export const getDeviceId = (meetingId: string, stateCode: string): string => {
  try {
    // Create a unique key for this meeting and state code combination
    const storageKey = `${meetingId}_${stateCode}`;
    
    // Try to get existing device IDs
    const storedDeviceIds = JSON.parse(localStorage.getItem(DEVICE_ID_KEY) || '{}') as StoredDeviceIds;
    
    // If we already have a device ID for this meeting and state code, return it
    if (storedDeviceIds[storageKey]) {
      return storedDeviceIds[storageKey];
    }
    
    // Create a new device ID for this meeting and state code
    const deviceId = `${uuidv4()}-${meetingId}-${stateCode}`;
    
    // Store the new device ID
    storedDeviceIds[storageKey] = deviceId;
    localStorage.setItem(DEVICE_ID_KEY, JSON.stringify(storedDeviceIds));
    
    return deviceId;
  } catch (error) {
    console.error('Error getting device ID:', error);
    // If there's an error with localStorage, generate a new ID
    return `${uuidv4()}-${meetingId}-${stateCode}`;
  }
};

export const clearDeviceId = (meetingId?: string, stateCode?: string): void => {
  try {
    if (meetingId && stateCode) {
      // Clear device ID for specific meeting and state code
      const storedDeviceIds = JSON.parse(localStorage.getItem(DEVICE_ID_KEY) || '{}') as StoredDeviceIds;
      const storageKey = `${meetingId}_${stateCode}`;
      delete storedDeviceIds[storageKey];
      localStorage.setItem(DEVICE_ID_KEY, JSON.stringify(storedDeviceIds));
    } else if (meetingId) {
      // Clear all device IDs for a specific meeting
      const storedDeviceIds = JSON.parse(localStorage.getItem(DEVICE_ID_KEY) || '{}') as StoredDeviceIds;
      Object.keys(storedDeviceIds).forEach(key => {
        if (key.startsWith(`${meetingId}_`)) {
          delete storedDeviceIds[key];
        }
      });
      localStorage.setItem(DEVICE_ID_KEY, JSON.stringify(storedDeviceIds));
    } else {
      // Clear all device IDs
      localStorage.removeItem(DEVICE_ID_KEY);
    }
  } catch (error) {
    console.error('Error clearing device ID:', error);
    localStorage.removeItem(DEVICE_ID_KEY);
  }
}; 